import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SearchableDropdown from '../SearchableDropdown';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import {
  FormControl, InputLabel, MenuItem, Select,

} from "@mui/material";
import './Inputs.css'

function InputsComponent({approver=false,inputs,handleAddInput,handleDeleteInput,handleInputChange,hnadleHoursInputChange,inputHours=[],disabled}) {

  


  return (
    <div>
      {inputs.map((input, index) => (
        <div style={{display:"flex",alignItems:'center',gap:10,marginBottom:'10px'}} key={index}>
          {/* <TextField
            label={`TM & SKU ${index + 1}`}
            variant="outlined"
            value={input}
            style={{marginTop:'5px',marginBottom:'5px'}}
            onChange={(e) => handleInputChange(index, e.target.value)}
          /> */}
          {approver ? <>
          {/* <div></div> */}
          {/* <div style={{width:'100%'}}> */}
          <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id="subs_id">Subscription</InputLabel> */}
                                <TextField label='Hours' disabled value={'Hours'}  required/>
                                {/* <Select
                                    id="subs_id"
                                    labelId="Subscription"
                                    name="SubscriptionID"
                                    value={getField("SubscriptionID")}
                                    label="Subscription"
                                    disabled={true}
                                    // onChange={handleChangeSubscription}
                                    // disabled={readonly}0
                                >
                                    {['TYooMQauvdEDq54NiTphI7jx','4eC39HqLyjWDarjtT1zdp7dc',].map((sub:string,index:number)=>(
                                        <MenuItem key={index} value={sub}>{sub}</MenuItem>
                                    ))}
                                </Select> */}
                            </FormControl>
                            <FormControl variant="standard" fullWidth>

                            <TextField type='number' label='Hours Count' min='0' disabled value={inputHours[index]}  required/>
                            </FormControl>

          {/* </div> */}
                            {/* <div style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>

      <p>Total Cost: </p>
      <p>$585.12</p>

                            </div> */}

          </> 
                            : (
            <>
          {/* <SearchableDropdown
                                label="Hours" 
                              
                                
                                action="searchAccount" 
                                style={{marginTop:'5px',marginBottom:'5px'}}
                                //params={{acid:'0011P00001E3bAoQAJ'}}
                                onSelect={(e:any)=>  handleInputChange(index, e?.target?.value)} 
                            />   */}
 {/* <InputLabel id="CSP">CSP</InputLabel> */}
                                <Select
                                    id="hours_id"
                                    labelId="Hours"
                                    name="Hours"
                                    // value={'Hours'}
                                    defaultValue={'Hours'}
                                    // onChange={(e:any)=>  handleInputChange(index, e?.target?.value)}
                                    disabled={true}
                                >
                                   {['Hours','Monday','Tuesday','Wednesday','Thursday','Friday','Satuarday','Sunday'].map((csp:string,index:number)=>(
                                        <MenuItem key={index} value={csp}>{csp.toUpperCase()}</MenuItem>
                                    ))}
                                    {/* {['Aviatrix csp','zoom csp','billing csp'].map((csp:string,index:number)=>(
                                        <MenuItem key={index} value={csp}>{csp.toUpperCase()}</MenuItem>
                                    ))} */}
                                </Select>
                             <TextValidator
                                      size="small" 
                                      fullWidth
                                      variant="outlined" 
                                      type="number" 
                                      label="Hours Count"  
                                      // margin="dense"
                                      placeholder='' 
                                      name={`workedHours ${index}`}
                                      value={inputHours[index]}
                                      autoFocus
                                      disabled={disabled}
                                      min='0'
                                      // InputProps={{ inputProps: {  min: 0.01, max: 500 ,step:0.01},startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                                      // value={UnitPrice.toFixed(3)}
                                      onChange={(e)=>hnadleHoursInputChange(index, e?.target?.value)} 
                                      // validators={["required"]}
                                      // errorMessages={["UnitPrice is required"]}
                                  /> 
          <Button
          style={{marginTop:'5px'}}
            variant="contained"
            color="secondary"
            onClick={() => handleDeleteInput(index)}
            disabled={disabled}
          >
            Delete
          </Button>
            </>
          )}
        </div>
      ))}
      {!approver ?(

      <Button
      style={{marginTop:'10px'}}
        variant="contained"
        color="primary"
        onClick={handleAddInput}
        disabled={disabled}
      >
        Add More SKU'S
      </Button>
      ):null}
    </div>
  );
}

export default InputsComponent;
